import HighchartsReact from "highcharts-react-official";
import { Stack, Typography } from "@mui/material";
import React, { useRef } from "react";

import { CashflowGraph, ReportCashflowAllocationTarget, ReportCashflowAum } from "store/types";
import { AllocationTarget, IAllocationTarget } from "./Allocation-target/AllocationTarget";
import { ChartSettings } from "./Chart-settings/ChartSettings";
import { AsyncContentMui } from "components";
import { Chart } from "./Chart";

interface IProps {
  currentSetId: number | null;
  data: CashflowGraph | undefined;
  loadingStatus: {
    aumLoading: boolean;
    allocationTargetLoading: boolean;
    graphLoading: boolean;
  };
  aumData: ReportCashflowAum | null;
  allocationTargetData: ReportCashflowAllocationTarget[];
  updateAllocationTarget: (data: { aum_id: number; targets: IAllocationTarget[] }) => void;
  updateAumData: (data: { set_id: number; aum_enabled: boolean; total_aum: number }) => void;
}

export const ChartWrapper: React.FC<IProps> = ({
  currentSetId,
  data,
  loadingStatus,
  aumData,
  updateAumData,
  allocationTargetData,
  updateAllocationTarget
}) => {
  const chartRef = useRef<HighchartsReact.RefObject>(null);

  return (
    <Stack
      sx={{
        gap: "8px",
        p: "16px",
        borderRadius: "8px",
        boxShadow: "0px 1px 2px rgba(18, 18, 23, 0.1)",
        bgcolor: "#fff",
        minHeight: 400,
        maxHeight: 400
      }}
    >
      <Stack sx={{ flexDirection: "column", justifyContent: "space-between" }} gap="10px">
        <Typography sx={{ fontWeight: 500, fontSize: "18px", lineHeight: "24px", color: "#071F35" }}>
          Prediction
        </Typography>
        <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
          <AllocationTarget
            allocationTargetData={allocationTargetData}
            updateAllocationTarget={updateAllocationTarget}
            aumData={aumData}
            loadingStatus={loadingStatus}
          />
          <ChartSettings
            loadingStatus={loadingStatus}
            currentSetId={currentSetId}
            aumData={aumData}
            chartRef={chartRef}
            updateAumData={updateAumData}
          />
        </Stack>
      </Stack>
      <AsyncContentMui isLoading={loadingStatus.graphLoading || loadingStatus.aumLoading} spinnerProps={{ size: 75 }}>
        <Chart data={data} chartRef={chartRef} aumData={aumData} />
      </AsyncContentMui>
    </Stack>
  );
};
